window.productResourcesHandler = () => {
  const selectedIds = {
    tags: [],
  };
  let allResources = '';

  document.addEventListener('DOMContentLoaded', () => {
    loadFilters();
    handleClickFilter();
    handleClickDeleteFilterTag();
    handleClickClearAll();
    getAllResourcesFromDOM();
  });

  const loadFilters = () => {
    const url = window.location.href;

    if (url.includes("tags")) {
      const tags = queryParamEvents("get", "tags")?.split('-') || []
      const ids = {
        tags,
      }
      const baseUrl = url.split('/').slice(0, -1).join("/") + "/";
      const filters = document.querySelectorAll('.jsGallerySearchItem');
      const filterTagsContainer = document.querySelector('.jsGalleryNavTags');

      filters && filters.forEach(filter => {
        const filterType = filter.getAttribute('data-type');
        const filterId = filter.getAttribute('data-id');

        // Set filter as selected when query param includes filter id
        if (ids[filterType].includes(filterId)) {
          toggleAddFilterTag(filterTagsContainer, filter);
        }
      });

      // Update available filters ids
      getAvailableFiltersIds(baseUrl);
    }
  }

  const createFilterTag = (baseTag, type, id, name) => {
    const tag = baseTag.cloneNode(true);
    const tagName = tag.querySelector('.jsGalleryNavTagsText');

    tag.setAttribute('data-id', id);
    tag.setAttribute('data-type', type);
    tag.removeAttribute('style'); // Remove hidden style
    tag.classList.remove('jsGalleryBaseTag'); // Only for base tag
    tagName.innerText = name;

    return tag;
  };

  const addFilterTag = (filterTagsContainer, type, id, name) => {
    const baseTag = filterTagsContainer.querySelector('.jsGalleryBaseTag');
    const tag = createFilterTag(baseTag, type, id, name);

    // Add to DOM
    filterTagsContainer.appendChild(tag);
    // Add to selectedIds
    toggleSetSelectedIds('add', type, id);
    // Set color
    toggleSetSelectedFilters(type);
  };

  const deleteFilterTag = (filterTagsContainer, type, id) => {
    const tag = filterTagsContainer.querySelector(`.jsGalleryNavTagsItem[data-type="${type}"][data-id="${id}"]`);

    // Remove from DOM
    tag.remove();
    // Delete from selectIds
    toggleSetSelectedIds('delete', type, id);
    // Set color
    toggleSetSelectedFilters(type);
  };

  const toggleSetSelectedIds = (action, type, id) => {
    if (action === 'add') {
      !selectedIds[type].find(itemId => itemId === id) && selectedIds[type].push(Number(id));
    } else if (action === 'delete') {
      selectedIds[type] = [...selectedIds[type]].filter(itemId => Number(itemId) !== Number(id));
    }
  };

  const toggleSetSelectedFilters = (type) => {
    const filtersByType = document.querySelectorAll(`.jsGallerySearchItem[data-type=${type}]`);

    filtersByType.forEach(filter => {
      const label = filter.querySelector('label');
      const filterId = filter.getAttribute('data-id');
      const selectedFilter = selectedIds[type].find(id => Number(id) === Number(filterId));
      selectedFilter
        ? label.classList.add('enable') // Add checked color
        : label.classList.remove('enable'); // Remove checked color
    });
  };

  const toggleAddFilterTag = (filterTagsContainer, filter) => {
    const filterLabel = filter.querySelector('label');
    const id = filter.getAttribute('data-id');
    const type = filter.getAttribute('data-type');
    const name = filter.querySelector('label').innerText;
    const isFilterAvailable = !filterLabel.classList.contains('disable');
    const isFilterChecked = selectedIds[type].find(itemId => itemId === Number(id));

    isFilterAvailable && (isFilterChecked
        ? deleteFilterTag(filterTagsContainer, type, id) // Remove tag when is not disabled and is checked
        : addFilterTag(filterTagsContainer, type, id, name) // Add tag when is not disabled and isn't checked
    );
  };

  const reloadFilterContent = () => {
    const {tags} = selectedIds;
    const existingList = document.querySelector('#productResourcesList');

    let url = window.location.origin + window.location.pathname + "load-more/finishes/";
    if (tags && tags.length > 0) {
      const params = tags.map(tag => `finish-tags=${tag}`).join('&');
      url += '?' + params;
    }
    // Always make server request, even when no tags are present, to get fresh unfiltered data

    fetch(url, {
      method: "GET",
      headers: {
        "X-CSRFToken": getCookie("csrftoken"),
      },
    })
      .then(response => response.text())
      .then(htmlString => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        const ulElement = doc.querySelector('#productResourcesList');
        if (existingList) {
          existingList.replaceWith(ulElement);
          window.downloadHandler();
          window.upholsteryHandler();
          setQueryParams(selectedIds);
        }
      })
      .catch(err => console.log(`Error - ${err}`));
  }

  const getAvailableFiltersIds = () => {
    const tags = selectedIds.tags;

    let url = window.location.origin + window.location.pathname + "load-more/finishes/";
    const formData = new FormData();
    tags.forEach(tag => {
      formData.append('tags', tag);
    });
    fetch(url, {
      method: 'POST',
      headers: {
        "X-CSRFToken": getCookie("csrftoken"),
      },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        const availableTags = data.tags || [];

        // Update UI - show/hide and enable/disable tags
        const filters = document.querySelectorAll('.jsGallerySearchItem[data-type="tags"]');
        filters.forEach(filter => {
          const tagId = parseInt(filter.getAttribute('data-id'));
          const label = filter.querySelector('label');

          if (availableTags.includes(tagId) || selectedIds.tags.includes(tagId)) {
            // Tag is available or currently selected - show and enable
            filter.classList.remove('disabled');
            filter.style.display = '';
            label.classList.remove('disable');
          } else {
            // Tag would yield no results - grey out and disable
            filter.classList.add('disabled');
            label.classList.add('disable');
          }
        });
      })
      .catch(err => {
        console.log('Error updating available tags:', err);
      });
  };

  const setQueryParams = (data) => {
    Object.keys(data).forEach(item => {
      const value = data[item];
      const convertedValue = value.join('-') || "";
      const queryType = value.length ? "set" : "delete";

      queryParamEvents(queryType, item, convertedValue);
    });
  };

  const handleClickFilter = () => {
    const filters = document.querySelectorAll('.jsGallerySearchItem');
    const filterTagsContainer = document.querySelector('.jsGalleryNavTags');

    filters && filters.forEach(filter => {
      filter.addEventListener('click', (e) => {
        e.preventDefault();
        // Add tag when isn't selected and delete if is selected
        toggleAddFilterTag(filterTagsContainer, filter);
        // Update available filters ids
        getAvailableFiltersIds();
        reloadFilterContent();
      });
    });
  };

  const handleClickDeleteFilterTag = () => {
    const filterTagsContainer = document.querySelector('.jsGalleryNavTags');

    filterTagsContainer.addEventListener('click', (e) => {
      const isDeleteIconTagParent = e.target.parentNode.classList.contains('jsGalleryCloseTag');

      const isDeleteIconTag = e.target.classList.contains('jsGalleryCloseTag');
      if (isDeleteIconTag || isDeleteIconTagParent) {
        const tag = e.target.closest('.jsGalleryNavTagsItem');
        const id = tag.getAttribute('data-id');
        const type = tag.getAttribute('data-type');

        // Delete tag
        deleteFilterTag(filterTagsContainer, type, id);
        // Update available filters ids
        getAvailableFiltersIds();
        reloadFilterContent();
      }
    });
  };

  const handleClickClearAll = () => {
    const clearButton = document.querySelector('.jsGalleryClearTags');
    const filterTagsContainer = document.querySelector('.jsGalleryNavTags');

    clearButton.addEventListener('click', () => {
      // Delete tag
      Object.keys(selectedIds).forEach(type => {
        selectedIds[type].forEach(id => {
          deleteFilterTag(filterTagsContainer, type, id);
        });
      });
      // Reset available filters ids
      getAvailableFiltersIds();
      reloadFilterContent();
    });
  };

  const getAllResourcesFromDOM = () => {
    const existingList = document.querySelector('#productResourcesList');
    allResources = existingList ? existingList : '';
  }
};
